module.exports = __webpack_public_path__ + "img/curva.41565c04.svg";